/** Body class toggled while Snapshot PDF (browser print) is active. */
export const SNAPSHOT_PRINT_BODY_CLASS = 'snapshot-print-mode';

/** Prepare DOM for Snapshot print; returns cleanup (also runs on `afterprint`). */
export function beginSnapshotPrint(): () => void {
  document.body.classList.add(SNAPSHOT_PRINT_BODY_CLASS);
  const cleanup = () => {
    document.body.classList.remove(SNAPSHOT_PRINT_BODY_CLASS);
  };
  window.addEventListener('afterprint', cleanup, { once: true });
  return cleanup;
}

/** Let React paint expanded tables/charts before the browser captures print. */
export function waitForPrintPaint(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(resolve, 150);
      });
    });
  });
}

/** Rows for paginated report tables — all rows when exporting to PDF. */
export function sliceForSnapshotPrint<T>(
  rows: T[],
  page: number,
  pageSize: number,
  includeAll: boolean,
): T[] {
  if (includeAll) return rows;
  return rows.slice(page * pageSize, (page + 1) * pageSize);
}
